import translations from "../translations"
import * as I18n from "../services/i18n"


window.loadHistoryModalListener = ->
# Listen for modal shown event to fix positioning
  $('#activity-history-modal').off('shown.bs.modal shown').on 'shown.bs.modal shown', ->
    modal = $(this)
    if modal.data('modal')
# Force layout recalculation for bootstrap-modal plugin
      setTimeout ->
        modal.data('modal').layout()
      , 50

  if $('.js-activity-history')[0]
    $('.js-activity-history').off('click').on 'click', ->
      filter = $(this).data('filter') || {}
      url = $(this).data('path')

      console.log(url)

      return unless url

      $('#activity-history-modal .modal-body').html('<p>' + I18n.t(translations(), 'shared.activity_history_loading') + '</p>')

      # Load first page
      $.ajax
        url: url
        data: $.extend(filter, { page: 1, per_page: 5 })
        method: 'GET'
        success: (response) ->
          modalBody = $('#activity-history-modal .modal-body')
          modalBody.html(response)

          # Force the modal to recalculate position after content is loaded
          # Using requestAnimationFrame to ensure DOM is updated
          window.requestAnimationFrame ->
            window.requestAnimationFrame ->
# Get fresh reference to modal
              modal = $('#activity-history-modal')

              # If using bootstrap-modal plugin (the one with data-width attribute)
              if modal.data('modal')
# This is likely bootstrap-modal plugin, not standard Bootstrap
                modal.data('modal').layout()

              # Fallback: dispatch resize event
              window.dispatchEvent(new Event('resize'))

          attachLoadMoreHandler(filter, url)
        error: ->
          $('#activity-history-modal .modal-body').html('<p>' + I18n.t(translations(), 'shared.activity_history_loading.error_loading') + '</p>')

# Function to attach load more handler
attachLoadMoreHandler = (filter, url) ->
  console.log('attach', filter, url)

  # Use event delegation to handle clicks on dynamically added button
  $(document).off('click', '#load-more-history').on 'click', '#load-more-history', ->
    button = $(this)
    console.log('load-more-history clicked')
    spinner = button.find('.spinner-border')
    page = button.data('page')

    # Find the container and tbody in the same context as the button
    container = button.closest('#activity-history-container')
    targetTbody = container.find('#activity-history-tbody')
    targetInfo = container.find('.activity-history-info')

    console.log('Container found:', container.length)
    console.log('Target tbody in context:', targetTbody.length)

    # Show spinner and disable button
    spinner.removeClass('d-none')
    button.prop('disabled', true)

    $.ajax
      url: url
      data: $.extend(filter, { page: page, per_page: 5 })
      method: 'GET'
      success: (response) ->
        console.log('Load more success')
        # Extract only the tbody content from response
        tempDiv = $('<div>').html(response)
        newRows = tempDiv.find('tbody#activity-history-tbody').html()
        newButton = tempDiv.find('#load-more-history')

        console.log('New rows HTML:', newRows)

        # Append new rows to existing tbody in the same context
        if newRows && targetTbody.length > 0
          targetTbody.append(newRows)
          console.log('Rows appended to context tbody')
          console.log('New tbody content length:', targetTbody.find('tr').length)

        # Update or remove load more button
        if newButton.length > 0
          button.data('page', newButton.data('page'))
          button.prop('disabled', false)
          spinner.addClass('d-none')
        else
          button.remove()

        # Update showing records text in the same context
        infoDiv = tempDiv.find('.activity-history-info')
        if infoDiv.length > 0 && targetInfo.length > 0
          targetInfo.html(infoDiv.html())
      error: ->
        console.log('Load more error')
        button.prop('disabled', false)
        spinner.addClass('d-none')
        alert(I18n.t(translations(), 'shared.activity_history.error_loading_more'))



$(document).on 'turbolinks:load', ->
  loadHistoryModalListener()
